import PropTypes from 'prop-types';

// ----------------------------------------------------------------------

export default function DeviceLayout({ children }) {
  return <>{children}</>;
}

DeviceLayout.propTypes = {
  children: PropTypes.node,
};
